export const ACHIEVEMENT_BADGE_THEMES = {
	light: 'light',
	dark: 'dark',
};
